import React from 'react';
import { Card, CardContent, Typography, Box, makeStyles } from '@material-ui/core';

const gradients = [
  'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  'linear-gradient(135deg, #d4a853 0%, #b8892e 100%)',
  'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
  'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
  'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
];

const glows = [
  'rgba(16,185,129,0.35)',
  'rgba(212,168,83,0.35)',
  'rgba(99,102,241,0.35)',
  'rgba(245,158,11,0.35)',
  'rgba(236,72,153,0.35)',
];

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    borderRadius: 20,
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
    overflow: 'hidden',
    position: 'relative',
    transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
    cursor: 'default',
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 16px 48px rgba(0,0,0,0.4)',
      border: `1px solid ${theme.palette.divider}` },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      borderRadius: '20px 20px 0 0' } },
  content: {
    padding: '24px !important',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between' },
  left: {
    flex: 1 },
  label: {
    fontSize: '0.72rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    marginBottom: 8 },
  value: {
    fontWeight: 800,
    fontSize: '2.2rem',
    color: theme.palette.text.primary,
    lineHeight: 1,
    fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
    letterSpacing: '-0.03em' },
  trend: {
    marginTop: 8,
    fontSize: '0.72rem',
    color: '#10b981',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 4 },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 52,
    height: 52,
    borderRadius: 16,
    color: '#FFFFFF',
    flexShrink: 0,
    '& svg': { fontSize: 22 } },
  glowBg: {
    position: 'absolute',
    bottom: -20,
    right: -20,
    width: 100,
    height: 100,
    borderRadius: '50%',
    opacity: 0.06,
    pointerEvents: 'none' } }));

export default function StatCard({ icon, value, label, index = 0, onClick, style, subText }) {
  const classes = useStyles();
  
  const gradient = gradients[index % gradients.length];
  const glow = glows[index % glows.length];

  return (
    <Card
      className={classes.card}
      onClick={onClick}
      style={{
        '--glow': glow,
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: gradient,
          borderRadius: '20px 20px 0 0' }}
      />
      <div
        className={classes.glowBg}
        style={{ background: gradient }}
      />
      <CardContent className={classes.content}>
        <Box className={classes.left}>
          <Typography className={classes.label}>{label}</Typography>
          <Typography className={classes.value}>{value}</Typography>
          <Typography className={classes.trend}>{subText || '↑ Active'}</Typography>
        </Box>
        <Box
          className={classes.iconWrapper}
          style={{
            background: gradient,
            boxShadow: `0 6px 20px ${glow}` }}
        >
          {icon}
        </Box>
      </CardContent>
    </Card>
  );
}